// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import constants from "@store/constants";
import { TaxExemptionCertificatesDataViewContext } from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesSelectors";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/TaxExemptionCertificates/Handlers/UpdateSearchFields";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface TaxExemptionCertificatesPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const orderHistoryPaginationStyles: TaxExemptionCertificatesPaginationStyles = {};

const styles = orderHistoryPaginationStyles;

const TaxExemptionCertificatesPagination = ({ updateSearchFields }: Props) => {
    const taxExemptionCertificatesDataView = usePersistentDataView(useContext(TaxExemptionCertificatesDataViewContext));
    const pagination =
        taxExemptionCertificatesDataView.value && taxExemptionCertificatesDataView.pagination
            ? taxExemptionCertificatesDataView.pagination
            : undefined;

    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    const pageSizeCookieName = "TaxExemptionCertificates-PageSize";

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie={pageSizeCookieName}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TaxExemptionCertificatesPagination),
    definition: {
        displayName: "Pagination",
        group: constants.widgetGroup.taxExemptionCertificates as any,
        allowedContexts: [],
    },
};

export default widgetModule;
